var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pc-tooltip',{attrs:{"disabled":!_vm.tooltipText,"value":_vm.tooltipText ? _vm.tooltipText : ''}},[_c('div',{staticClass:"pc-status-detail"},[(_vm.detail)?_c('span',{class:_vm.dotClasses,style:(_vm.dotStyle)}):_vm._e(),(_vm.detail)?_c('span',{staticClass:"pc-status-detail-text"},[_vm._v(_vm._s(_vm.detailDisplayText))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }